module.exports = __webpack_public_path__ + "static/media/neurovalens.2303e8f9.png";